import { Controller } from "@hotwired/stimulus"

// Work kit issue-card controller (W1 Track B) — the emission half of the
// quick-transitions affordance on Ui::Work::Issue::CardComponent. The card
// root wires `click->ui--work-card#requestTransition`; a click that lands on
// a dropdown item carrying `data-work-transition-id` (the host-injected
// transition defs) becomes exactly one event and NOTHING else:
//
//   ui--work:card-transition-request { issue_id, transition_id, gesture_token }
//
// dispatched on the card root, bubbling — hosts listen on any ancestor. The
// gesture_token travels verbatim to the host's revert path per the kernel's
// translate-verbatim rule (F4 Layer 0 seam). Zero network, zero local state:
// events are the only API (anti-idea 2), selection mutates nothing.
//
// Disabled items (the host's permission flags, rendered as a disabled button
// by Ui::DropdownMenu::ItemComponent) never emit — the affordance draws
// disabled but stays inert.
export default class extends Controller {
  requestTransition(event) {
    const item = event.target.closest("[data-work-transition-id]")
    // Card-body clicks (select, open) are not transition requests.
    if (!item) return
    // Disabled def — the host's permission flag; render-disabled stays inert.
    if (item.disabled || item.hasAttribute("disabled")) return

    const transitionId = item.getAttribute("data-work-transition-id")
    if (!transitionId) return

    this.dispatchOnRoot("card-transition-request", {
      issue_id: this.element.dataset.issueId,
      transition_id: transitionId,
      gesture_token: `work-card-${Math.random().toString(36).slice(2, 10)}`,
    })
  }

  // Bubbling + cancelable on the card root (Stimulus dispatch targets this
  // element by default; an explicit custom prefix keeps the "ui--work" family
  // namespace the kernel's events use).
  dispatchOnRoot(name, detail) {
    this.element.dispatchEvent(
      new CustomEvent(`ui--work:${name}`, {
        bubbles: true,
        cancelable: true,
        detail,
      }),
    )
  }
}
